import { GroupHeader } from 'office-ui-fabric-react';
import { DefaultButton, IconButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import { DetailsList, SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { ScrollablePane, ScrollbarVisibility } from 'office-ui-fabric-react/lib/ScrollablePane';
import { SearchBox } from 'office-ui-fabric-react/lib/SearchBox';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { Sticky, StickyPositionType } from 'office-ui-fabric-react/lib/Sticky';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import React, { Component, Fragment } from 'react';
import PerimetreContext from '../../contexts/PerimetreContext';
import { DataRepartiteur } from '../../data/DataRepartiteur';
import { Immocom } from '../../specifique/immocom';
import { EUIDialog } from '../EUI/EUIDialog';
import { FicheRepartiteur } from '../Fiche/FicheRepartiteur';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';

export class DetailsListRepartiteur extends Component {
    static contextType = PerimetreContext;
    render = () => {
        const { perimetre } = this.context;
        return <DetailsListRepartiteurWithPerimetre {...this.props} perimetre={perimetre} />;
    };
};

class DetailsListRepartiteurWithPerimetre extends Component {

    static defaultState = {
        afficherDialogSuppression: false,
        afficherPanelRepartiteur: false,
        groups: [],
        idPerimetreLead: 0,
        items: [],
        mandatNational: true,
        /* --- */
        pageIndex: 1,
        facteurNbreEnregistrement: 100,
        recherche: '',
        tri: '',
    };

    constructor(props) {
        super(props);
        this.state = { ...DetailsListRepartiteurWithPerimetre.defaultState };
        this._columns = this._getColumns();
    };

    _chargementDonnees = () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Chargement des répartiteurs en cours'
        });

        const { tri, recherche, facteurNbreEnregistrement, pageIndex } = this.state;
        DataRepartiteur._chargementDesPerimetre_RegleLead_Comptes(tri, recherche, facteurNbreEnregistrement, pageIndex).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const retourData = responseFetch.reponseAPIobjet;
                const state = {
                    groups: this._getGroups(retourData[0]),
                    items: retourData[0],
                    mandatNational: retourData[1] //MG - 2366
                };
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, state);
            }
            else {
                const state = { items: [] };
                Immocom.onTraitementErreurAvecState(this, state, retourVerif, responseFetch);
            }
        });

    };

    _getColumns = () => {
        return [{
            className: 'ms-hiddenMdDown',
            headerClassName: 'ms-hiddenMdDown',
            isResizable: true,
            key: 'region',
            maxWidth: 200,
            minWidth: 150,
            name: 'Région',
            onRender: (item) => {
                const region = item.region;
                return <span title={region}>{region}</span>;
            }
        }, {
            className: 'ms-hiddenMdDown',
            headerClassName: 'ms-hiddenMdDown',
            isResizable: true,
            key: 'agence',
            maxWidth: 200,
            minWidth: 150,
            name: 'Agence',
            onRender: (item) => {
                const agence = item.agence;
                return <span title={agence}>{agence}</span>;
            }
        }, {
            className: 'ms-hiddenMdDown',
            headerClassName: 'ms-hiddenMdDown',
            isResizable: true,
            key: 'nomCommercial',
            maxWidth: 200,
            minWidth: 150,
            name: 'Opération',
            onRender: (item) => {
                const nomCommercial = item.nomCommercial;
                return <span title={nomCommercial}>{nomCommercial}</span>;
            }
        }, {
            isResizable: true,
            key: 'nom',
            maxWidth: 150,
            minWidth: 100,
            name: 'Règle',
            onRender: (item) => {
                const nom = item.nom;
                return <span title={nom}>{nom}</span>;
            }
        }, {
            isResizable: true,
            key: 'societe',
            maxWidth: 150,
            minWidth: 100,
            name: 'Société',
            onRender: (item) => {
                const societe = item.societe;
                return <span title={societe}>{societe}</span>;
            }
        }, {
            isResizable: true,
            key: 'loginCompte',
            maxWidth: 150,
            minWidth: 100,
            name: 'Compte',
            onRender: (item) => {
                const loginCompte = item.loginCompte;
                return <span title={loginCompte}>{loginCompte}</span>;
            }
        }];
    };

    _getItems = () => {
        return [{
            key: 'search',
            onRender: () => <SearchBox
                className="searchBox"
                onClear={(e) => this._onSearch("")}
                onSearch={value => this._onSearch(value)}
                placeholder="Recherche rapide"
            />
        }, {
            key: 'nouveau',
            name: 'Nouvelle règle',
            iconProps: { iconName: 'Add' },
            onClick: this._togglePanelRepartiteur(true, 0, this.state.mandatNational)
        }]
    };

    _getFarItems = () => {
        return [{
            key: "nombreEnregistrement",
            name: this.state.items.length
        }];
    };

    _getGroups = (listeRepartiteurs) => {

        const repartiteursGroupeesParPerimetre = listeRepartiteurs.reduce((memo, perimetre) => {
            const idRegion = perimetre.idRegion;
            const idAgence = perimetre.idAgence;
            const idOperation = perimetre.idOperation;
            const constPerimetre = idRegion + '-' + idAgence + '-' + idOperation;

            if (!memo[constPerimetre])
                memo[constPerimetre] = [];
            memo[constPerimetre].push(perimetre);
            return memo;
        }, {});

        let groups = [];
        let startIndex = 0
        for (const [constPerimetre, perimetres] of Object.entries(repartiteursGroupeesParPerimetre)) {
            const { nomCommercial, region, agence, idPerimetreLead } = perimetres[0];
            const count = perimetres.length;

            let labels = [];
            if (!!region) labels.push(region);
            if (!!agence) labels.push(agence);
            if (!!nomCommercial) labels.push(nomCommercial);
            const name = labels.join(" - ") || "National";

            groups.push({ key: idPerimetreLead, name, startIndex, count });
            startIndex += count;
        };
        return groups;

    };

    _onRenderDetailsHeader = (props, defaultRender) => {
        return <Sticky stickyPosition={StickyPositionType.Header} isScrollSynced={true}>
            {defaultRender({
                ...props,
                onRenderColumnHeaderTooltip: (tooltipHostProps) => <TooltipHost {...tooltipHostProps} />
            })}
        </Sticky>;
    };

    _onRenderGroupHeader = (props) => {
        const onRenderTitle = (renderTitleProps, defaultRender) => {
            return <Stack horizontal verticalAlign="center" horizontalAlign="space-between" styles={{ root: { width: "100%" } }}>
                {defaultRender(renderTitleProps)}
                <div>
                    <IconButton
                        iconProps={{ iconName: "Edit" }}
                        onClick={this._togglePanelRepartiteur(true, props.group.key, this.state.mandatNational)}
                        styles={{ root: { paddingRight: "12px" } }}
                        title="Modifier les règles du périmètre"
                    />
                    <IconButton
                        iconProps={{ iconName: "Delete" }}
                        onClick={this._toggleDialogSuppression(true, props.group.key)}
                        styles={{ root: { paddingRight: "12px" } }}
                        title="Supprimer les règles du périmètre"
                    />
                </div>
            </Stack>
        };
        return <GroupHeader {...props} onRenderTitle={onRenderTitle} />;
    };

    _onSearch = (text) => {
        this.setState({
            recherche: text,
            pageIndex: 1
        }, this._chargementDonnees);
    };

    _supprimerPerimetreRegleLeadComptes = (idPerimetreLead) => () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Suppression de répartiteur en cours'
        });

        DataRepartiteur._onSuppressionPerimetre_RegleLead_Compte(idPerimetreLead).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null)
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, {}, this._chargementDonnees);
            else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
        });
    };

    _togglePanelRepartiteur = (isOpen, idPerimetreLead, mandatNational, callback) => () => {
        this.setState(
            {
                afficherPanelRepartiteur: isOpen,
                idPerimetreLead,
                mandatNational
            },
            !!callback && typeof callback === "function" ? callback() : null
        );
    };

    _toggleDialogSuppression = (isOpen, idPerimetreLead, callback) => () => {
        this.setState(
            {
                afficherDialogSuppression: isOpen,
                idPerimetreLead,
            },
            !!callback && typeof callback === "function" ? callback() : null
        );
    };

    componentDidMount = () => {
        this._chargementDonnees();
    };

    //componentDidUpdate = () => {
    //    if (localStorage.getItem("onRecharge") === "true") {
    //        localStorage.setItem("onRecharge", "false");
    //        this.setState(
    //            { pageIndex: 1 },
    //            this._chargementDonnees
    //        );
    //    }
    //};

    componentDidUpdate = (prevProps) => {
        const { perimetre } = this.props;
        if (JSON.stringify(prevProps.perimetre) !== JSON.stringify(perimetre))
            this.setState({ pageIndex: 1 }, this._chargementDonnees);
    };

    render = () => {

        const { afficherDialogSuppression, afficherPanelRepartiteur, groups, items, idPerimetreLead, mandatNational } = this.state;

        return <Fragment>

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <Stack verticalFill>
                <CommandBar
                    farItems={this._getFarItems()}
                    items={this._getItems()}
                />
                <MessageBars
                    errorMessage={this.state.errorMessage}
                    infoMessage={this.state.messageMessageBarFiltres}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />
                <div className="position-relative h-100">
                    <ScrollablePane scrollbarVisibility={ScrollbarVisibility.auto}>
                        <DetailsList
                            items={items}
                            columns={this._columns}
                            groupProps={{ showEmptyGroups: true }}
                            groups={groups}
                            selectionMode={SelectionMode.none}
                            compact
                            groupProps={{
                                onRenderHeader: this._onRenderGroupHeader,
                                showEmptyGroups: true
                            }}
                            onRenderDetailsHeader={this._onRenderDetailsHeader}
                        />
                    </ScrollablePane>
                </div>
            </Stack>

            <FicheRepartiteur
                idPerimetreLead={idPerimetreLead}
                mandatNational={mandatNational}
                isOpen={afficherPanelRepartiteur}
                onDismiss={this._togglePanelRepartiteur(false, 0, this.state.mandatNational)}
                onSave={this._togglePanelRepartiteur(false, 0, this.state.mandatNational, this._chargementDonnees)}
            />

            <EUIDialog
                buttons={[
                    <PrimaryButton key="save" onClick={this._toggleDialogSuppression(false, 0, this._supprimerPerimetreRegleLeadComptes(idPerimetreLead))} text="Supprimer" />,
                    <DefaultButton key="cancel" onClick={this._toggleDialogSuppression(false, 0)} text="Annuler" />
                ]}
                isOpen={afficherDialogSuppression}
                onDismiss={this._toggleDialogSuppression(false)}
                titre="Suppression des règles du périmètre"
            >
                Confirmez-vous la suppression de toutes les règles de répartiteur liées à ce périmètre ?
            </EUIDialog>

        </Fragment>;

    };

};